function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".es_svg__cls-2{fill:#c60b1e}"));

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M.84 14h18.32a10 10 0 000-8H.84a10 10 0 000 8z",
  fill: "#ffc400"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "es_svg__cls-2",
  d: "M19.16 14H.84a10 10 0 0018.32 0zM.84 6h18.32A10 10 0 00.84 6z"
});

function SvgEs(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "es_svg__Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _ref, _ref2, _ref3);
}

export default "data:image/svg+xml;base64,PHN2ZyBpZD0iQ2FwYV8xIiBkYXRhLW5hbWU9IkNhcGEgMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB2aWV3Qm94PSIwIDAgMjAgMjAiPjxkZWZzPjxzdHlsZT4uY2xzLTF7ZmlsbDojZmZjNDAwO30uY2xzLTJ7ZmlsbDojYzYwYjFlO308L3N0eWxlPjwvZGVmcz48cGF0aCBjbGFzcz0iY2xzLTEiIGQ9Ik0uODQsMTRIMTkuMTZhMTAsMTAsMCwwLDAsMC04SC44NGExMCwxMCwwLDAsMCwwLDhaIi8+PHBhdGggY2xhc3M9ImNscy0yIiBkPSJNMTkuMTYsMTRILjg0YTEwLDEwLDAsMCwwLDE4LjMyLDBaIi8+PHBhdGggY2xhc3M9ImNscy0yIiBkPSJNLjg0LDZIMTkuMTZBMTAsMTAsMCwwLDAsLjg0LDZaIi8+PC9zdmc+";
export { SvgEs as ReactComponent };